import { VERIFICATION } from "../../constants";

export const setDocumentFile = (field, file) => ({
  type: VERIFICATION.SET_DOCUMENT_FILE,
  payload: { field, file },
});